/** Trimmed-lowercase string tokens rejected by presence validation: the literals `"null"` / `"undefined"` and the empty string. One home for the validity vocabulary, which `isPresentValue` below and the ledger primitive normalizer both gate on; cross-file re-declaration is the QUAL-CONST-CROSS-FILE-VALUE-DEDUP-001 class. */
const INVALID_STRING_TOKENS: ReadonlySet<string> = new Set(['', 'null', 'undefined']);

/**
 * @runtime-derived-ssot-helper (const-leaf-pinned): the presence predicate DERIVED from `INVALID_STRING_TOKENS`,
 * homed beside its vocabulary so pure `utils/` leaves can value-import it without a forbidden cross-utils sibling
 * dependency. Stricter than truthiness in one direction and looser in the other: `0` and `false` are PRESENT,
 * while a token-set string, an empty array and an empty object are NOT. Keeping the predicate and the token set in
 * one leaf is the point -- a consumer holding only the set has to re-derive the trim/lowercase normalization, and
 * that re-derivation is exactly what drifted.
 */
export function isPresentValue(value: unknown): boolean {
	if (value === null || value === undefined) return false;
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		return !INVALID_STRING_TOKENS.has(normalized);
	}
	if (Array.isArray(value)) return value.length > 0;
	if (typeof value === 'object') return Object.keys(value).length > 0;
	return true;
}
